import { render, staticRenderFns } from "./PersonalAwayEntitlementApplyAwayForm.vue?vue&type=template&id=54bb22cc&scoped=true&"
import script from "./PersonalAwayEntitlementApplyAwayForm.vue?vue&type=script&lang=js&"
export * from "./PersonalAwayEntitlementApplyAwayForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54bb22cc",
  null
  
)

export default component.exports